import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../admin/firebase/config';
import './OrderConfirmation.css';

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrder();
  }, [orderId]);

  const fetchOrder = async () => {
    try {
      const orderDoc = await getDoc(doc(db, 'orders', orderId));
      if (orderDoc.exists()) {
        setOrder({ id: orderDoc.id, ...orderDoc.data() });
      } else {
        alert('Order not found');
        navigate('/qr');
      }
    } catch (error) {
      console.error('Error fetching order:', error);
      alert('Failed to load order');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner-large"></div>
        <p>Loading order...</p>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="error-container">
        <h2>Order not found</h2>
        <button onClick={() => navigate('/qr')}>Start New Order</button>
      </div>
    );
  }

  return (
    <div className="order-confirmation-page">
      <div className="success-animation">
        <div className="checkmark-circle">
          <div className="checkmark">✓</div>
        </div>
      </div>

      <div className="confirmation-content">
        <h1>Order Placed Successfully!</h1>
        <p className="success-message">Your food will be served shortly</p>

        <div className="order-details-card">
          <div className="detail-row">
            <span className="label">Order Number</span>
            <span className="value">#{order.orderNumber || order.id.slice(-6)}</span>
          </div>
          <div className="detail-row">
            <span className="label">Table</span>
            <span className="value">Table {order.tableNumber}</span>
          </div>
          <div className="detail-row">
            <span className="label">Payment Method</span>
            <span className="value capitalize">{order.paymentMethod}</span>
          </div>
          <div className="detail-row">
            <span className="label">Total Amount</span>
            <span className="value amount">₹{order.total?.toFixed(2)}</span>
          </div>
        </div>

        <div className="order-items-card">
          <h3>Order Items ({order.items?.length || 0})</h3>
          {order.items?.map((item, index) => (
            <div key={index} className="order-item">
              <div className="item-qty">{item.quantity}x</div>
              <div className="item-name">{item.name}</div>
              <div className="item-price">₹{(item.price * item.quantity).toFixed(2)}</div>
            </div>
          ))}
          
          {order.specialInstructions && (
            <div className="special-instructions">
              <strong>Special Instructions:</strong>
              <p>{order.specialInstructions}</p>
            </div>
          )}
        </div>

        <div className="action-buttons">
          <button 
            className="btn-track-order"
            onClick={() => navigate(`/qr/track/${orderId}`)}
          >
            📍 Track Order Status
          </button>
          
          <button 
            className="btn-new-order"
            onClick={() => navigate('/qr')}
          >
            Place Another Order
          </button>
        </div>

        <div className="info-section">
          <h4>What's Next?</h4>
          <ul>
            <li>✅ Your order has been sent to the kitchen</li>
            <li>🍳 Our chefs are preparing your food</li>
            <li>🚶 Staff will serve it to your table when ready</li>
            {order.paymentMethod === 'cash' && (
              <li>💵 Please keep cash ready for payment</li>
            )}
          </ul>
        </div>

        <div className="help-section">
          <p>Need help? Call a waiter or contact staff</p>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
